import { h, Host } from "@stencil/core";
/**
 * this component is a dynamic input field that allows users to add or remove input fields
 * @deprecated this component will be migrated to the ux.ui design system in the future
 */
export class DynamicInput {
    constructor() {
        this.baseClass = "service-calls-dynamic-input";
        this.inputIdCounter = 0;
        /** Add input text */
        this.addText = "+ add another error number";
        /** Input names with dynamically generated suffixes */
        this.inputName = "errorNumber";
        /** Initial items to be displayed */
        this.initItems = 1;
        /** Minimum items to be displayed */
        this.minItems = 1;
        /** Maximum items to be displayed */
        this.maxItems = 6;
        /** Prefilled values */
        this.prefilledValues = [];
        /** disabled input and disabled delete button */
        this.disabled = false;
        /** Regex to validate values */
        this.regex = "";
        /** Error message for invalid values */
        this.errorMessage = "";
        /** Counter for adding items  */
        this.counter = 0;
        /** Dynamic items */
        this.items = [];
        /** Minimum items reached */
        this.minReached = false;
        /** Maximum items reached */
        this.maxReached = false;
        this.addInput = () => {
            if (this.disabled)
                return;
            if (this.counter < this.maxItems) {
                this.counter++;
                this.items.push(this.createItem(""));
                this.minReached = false;
                this.checkMinMaxReached();
            }
        };
        this.removeInput = (id) => {
            if (this.disabled)
                return;
            if (this.counter > this.minItems) {
                this.counter--;
                const items = this.items.filter((item) => item.id !== id);
                this.items = items;
                this.checkMinMaxReached();
            }
        };
        this.checkMinMaxReached = () => {
            this.minReached = this.counter === this.minItems;
            this.maxReached = this.counter === this.maxItems;
        };
    }
    componentWillLoad() {
        this.setInitItems();
    }
    createItem(value) {
        return {
            value,
            id: `item-${this.inputIdCounter++}`
        };
    }
    setInitItems() {
        let count = 0;
        const items = [];
        for (let i = 0; i < this.initItems; i++) {
            count++;
            items.push(this.createItem(this.prefilledValues[i] || ""));
        }
        this.items = items;
        this.counter = count;
        this.checkMinMaxReached();
    }
    render() {
        return (h(Host, { key: '7285aab67b6fac982734a59ed97278e0761acb7b', class: `${this.baseClass}` }, h("div", { key: '250bb5f89de9c14757c55c53bddb00ed6371b628', class: `${this.baseClass}__dynamic-container ${this.minReached || this.disabled ? "is-min-reached" : ""}` }, this.items.map(({ id, value }) => {
            return (h("div", { class: `${this.baseClass}__input-container`, key: id }, h("ux-input-field", { type: "text", value: value, onUxInputChange: (e) => {
                    this.items = this.items.map((item) => {
                        if (item.id === id) {
                            return Object.assign(Object.assign({}, item), { value: e.detail.currentValue });
                        }
                        return item;
                    });
                }, name: this.inputName, disabled: this.disabled, "data-validation-regex--expression": value === "" ? "" : this.regex, "data-validation-regex--msg": this.errorMessage }), h("ux-icon", { name: "delete", onClick: () => this.removeInput(id) })));
        })), h("slot", { key: '129baa635a4ce65ac0abe1f61ff6d5c0e2582e52', name: "info" }), h("div", { key: '7852a995223d8c73de822798ce3b2c1dec709417', class: `ux-text-link ux-text-link--primary ${this.maxReached || this.disabled ? "is-max-reached" : ""}`, onClick: this.addInput }, this.addText)));
    }
    static get is() { return "service-calls-dynamic-input"; }
    static get originalStyleUrls() {
        return {
            "$": ["dynamic-input.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dynamic-input.css"]
        };
    }
    static get properties() {
        return {
            "addText": {
                "type": "string",
                "attribute": "add-text",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Add input text"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"+ add another error number\""
            },
            "inputName": {
                "type": "string",
                "attribute": "input-name",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Input names with dynamically generated suffixes"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"errorNumber\""
            },
            "initItems": {
                "type": "number",
                "attribute": "init-items",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Initial items to be displayed"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "1"
            },
            "minItems": {
                "type": "number",
                "attribute": "min-items",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Minimum items to be displayed"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "1"
            },
            "maxItems": {
                "type": "number",
                "attribute": "max-items",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Maximum items to be displayed"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "6"
            },
            "prefilledValues": {
                "type": "unknown",
                "attribute": "prefilled-values",
                "mutable": false,
                "complexType": {
                    "original": "string[]",
                    "resolved": "string[]",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Prefilled values"
                },
                "getter": false,
                "setter": false,
                "defaultValue": "[]"
            },
            "disabled": {
                "type": "boolean",
                "attribute": "disabled",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "disabled input and disabled delete button"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            },
            "regex": {
                "type": "string",
                "attribute": "regex",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Regex to validate values"
                },
                "getter": false,
                "setter": false,
                "reflect": true,
                "defaultValue": "\"\""
            },
            "errorMessage": {
                "type": "string",
                "attribute": "error-message",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Error message for invalid values"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"\""
            }
        };
    }
    static get states() {
        return {
            "counter": {},
            "items": {},
            "minReached": {},
            "maxReached": {}
        };
    }
    static get watchers() {
        return [{
                "propName": "prefilledValues",
                "methodName": "setInitItems"
            }];
    }
}
//# sourceMappingURL=dynamic-input.js.map
